import PropTypes from "prop-types";
import classNames from "classnames";
import React, { PureComponent } from "react";
import { Search } from "../../Common";
import { UnitsOfMeasureButton } from "../SortedList";

export default class PanelTools extends PureComponent {
  static propTypes = {
    changeUnits: PropTypes.func,
    className: PropTypes.string,
    isSearchVisible: PropTypes.bool,
    isUnitsOfMeasureVisible: PropTypes.bool,
    onSearch: PropTypes.func,
    searchQuery: PropTypes.string
  };

  static defaultProps = {
    changeUnits: null,
    className: "",
    isSearchVisible: false,
    isUnitsOfMeasureVisible: false,
    onSearch: null,
    searchQuery: ""
  };

  render() {
    return (
      <div className={classNames("panel-tools", this.props.className)}>
        {this.props.isSearchVisible && <Search value={this.props.searchQuery} onSubmit={this.props.onSearch} />}
        {this.props.isUnitsOfMeasureVisible && <UnitsOfMeasureButton changeUnits={this.props.changeUnits} />}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Layout/Panel/PanelTools.js